module.exports = __webpack_public_path__ + "img/partner18.f9284954.png";